import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import {SearchLearningFlowMapper} from '../mappers/search-learning-flow.mapper';

@Injectable({
    providedIn: 'root'
})
export class GetSearchLearningFlowUseCase {
    constructor(
        private mapper: SearchLearningFlowMapper,
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements
    ) {}

    run(keyword, skip, limit) {
      return this.data.getSearchLearningFlow(keyword, skip, limit).pipe(this.mapper.map);
    }
}
